import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCountries } from 'actions/countries';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class BuilderCountry extends React.Component {
    constructor(props) {
        super(props);
        
        this.changeSelect = this.changeSelect.bind(this);
    }

    changeSelect(e, i, value) {
        this.props.changeAutoComplete('builderV2.country', this.props.countries.find((country) => {
            return country._id === value;
        }));
    }

    UNSAFE_componentWillMount() {
        this.props.getCountries();
    }

    render() {
        const { getError, countries, confirmed, country, modifiedFields, underStyle } = this.props;
        return (
            <SelectField
                value={typeof country === 'string' ? country : country._id}
                onChange={this.changeSelect}
                errorText={getError('country')}
                maxHeight={200}
                name='builderCountry'
                disabled={confirmed}
                floatingLabelText='Country'
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('builderV2.country') ? underStyle : null}
            >
                {
                    countries.map((country, index) => {
                        return (
                            <MenuItem
                                key={index}
                                value={country._id}
                                primaryText={country.name}
                            />
                        );
                    })
                }
            </SelectField>
        );
    }
}

export default connect(
    ({ countries: { items } }) => {
        return {
            countries: items,
        };
    },
    dispatch => bindActionCreators({
        getCountries,
    }, dispatch),
)(BuilderCountry);



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/BuilderCountry.jsx